import { PortalStore } from '../../portal/portalStore/PortalStore';
import { RequestStore } from './RequestStore';

export class RequestStoreLocation {
  requestStore: RequestStore;

  constructor(requestStore) {
    this.requestStore = requestStore;
  }

  get pathurl() {
    return this.requestStore.requestData.resolvedUrl.split('?')[0];
  }
}
